module.exports = __webpack_public_path__ + "static/media/coinplug-logo-horizo.a7b6897c.png";